export default "__VITE_ASSET__f6af281b__"